export const LOAD_ALL_EMPLOYEES = 'LOAD_ALL_EMPLOYEES';
export const LOAD_EMPLOYEE_HISTORY = 'LOAD_EMPLOYEE_HISTORY';
export const LOAD_ALL_EMPLOYEES_FAILED = 'LOAD_ALL_EMPLOYEES_FAILED';
export const LOAD_EMPLOYEE = 'LOAD_EMPLOYEE';
export const SAVE_EMPLOYEES_FIELDS = 'SAVE_EMPLOYEES_FIELDS';
export const SAVE_EMPLOYEES_FAILED = 'SAVE_EMPLOYEES_FAILED';
export const DELETE_EMPLOYEE = 'DELETE_EMPLOYEE';
export const LOAD_WORKERS = 'LOAD_WORKERS';
export const LOAD_WORK_ORDER_NUMBERS = 'LOAD_WORK_ORDER_NUMBERS';
export const LOAD_SINGLE_WORKER = 'LOAD_SINGLE_WORKER';

export function loadAllEmployees(data) {
    return {
      type: LOAD_ALL_EMPLOYEES,
      payload: data,
    }
}

export function loadEmployee(data) {
  return {
    type: LOAD_EMPLOYEE,
    payload: data,
  }
}

export function loadEmployeeHistory(data) {
  return {
    type: LOAD_EMPLOYEE_HISTORY,
    payload: data,
  }
}

export function loadAllEmployeesFailed(data) {
    return {
      type: LOAD_ALL_EMPLOYEES_FAILED,
      payload: data,
    }
}

export function updateEmployeesFields(data) {
  return {
    type: SAVE_EMPLOYEES_FIELDS,
    payload: data,
  }
}

export function saveEmployeesFailed(data) {
  return {
    type: SAVE_EMPLOYEES_FAILED,
    payload: data,
  }
}

export function deleteEmployee(data) {
  return {
    type: DELETE_EMPLOYEE,
    payload: data,
  }
}

export function loadWorkers(data) {
  return {
    type: LOAD_WORKERS,
    payload: data,
  }
}

export function loadWorkOrderNumbers(data) {
  return {
    type: LOAD_WORK_ORDER_NUMBERS,
    payload: data,
  }
}

export function loadSingleWorker(data) {
  return {
    type: LOAD_SINGLE_WORKER,
    payload: data,
  }
}



// WEBPACK FOOTER //
// ./src/actions/employees/index.js